// extracted by mini-css-extract-plugin
export var container = "InfoContent-module--container--1RgXn";
export var homeLink = "InfoContent-module--homeLink--2xrYZ";
export var graphic = "InfoContent-module--graphic--IXD5w";
export var text = "InfoContent-module--text--czXEt";
export var listButton = "InfoContent-module--listButton--29pFz";